var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkboxRoot"},[_c('h5',{key:("filter-title-" + (_vm.filter.attribute_code)),staticClass:"checkboxTitle"},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.filter.attribute_code))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"slider",class:( _obj = {}, _obj['disabled'] = _vm.disabled, _obj )},[_c('div',{ref:"slider"})])])}
var staticRenderFns = []

export { render, staticRenderFns }